import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../services/auth.service';
import Swal from 'sweetalert2';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    private readonly ipProviders = ['https://ipapi.co/json/', 'https://api.ipify.org/?format=json', 'https://bigdatacloud.net/data/client-ip', 'https://us1.api-bdc.net/data/client-info'];

    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.ipProviders.some((url) => request.url.includes(url))) {
            return next.handle(request);
        }

        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                this.authenticationService.logout();
                location.reload();
            }
            const error = err?.error?.message || err?.error?.body || err?.statusText || 'Something went wrong';
            const trackingCode = err?.error?.error_time;
            Swal.fire({
                title: `Error`,
                icon: 'error',
                html: `
                    <p style="margin: 0 0 12px; font-size: 1em; color: inherit;">${error}</p>
                    ${trackingCode ? `
                    <div style="margin-top:6px;padding:8px 12px;background:#f8f9fa;border:1px solid #dee2e6;border-radius:4px;display:flex;align-items:center;justify-content:space-between;gap:8px;">
                        <code style="font-size:0.82em;word-break:break-all;color:#495057;">${trackingCode}</code>
                        <button type="button" onclick="(function(btn){navigator.clipboard.writeText('${trackingCode}').then(function(){btn.textContent='✓ Copied!';btn.style.background='#28a745';btn.style.color='white';btn.style.borderColor='#28a745';setTimeout(function(){btn.textContent='Copy';btn.style.background='white';btn.style.color='#6c757d';btn.style.borderColor='#dee2e6';},1500);})})(this)" style="flex-shrink:0;padding:4px 12px;font-size:0.8em;border:1px solid #dee2e6;border-radius:4px;background:white;color:#6c757d;cursor:pointer;transition:all 0.2s;font-weight:500;letter-spacing:0.02em;">Copy</button>
                    </div>
                    <p style="margin: 10px 0 0; font-size: 0.85em; color: #6c757d;">Share this code with the administrator, to solve the issue.</p>
                    ` : ''}
                `,
                showCancelButton: false,
                confirmButtonText: 'Ok',
            });
            return throwError(error);
        }))
    }
}
